import React, { memo } from 'react';

const PricingRulesAdvancedSearch: React.FC = () => {
  return <></>;
};

export default memo(PricingRulesAdvancedSearch);
